import { removeAuthorization, removeUserInfo } from "utils/storage/local";

const signOut = () => {
  removeAuthorization();
  removeUserInfo();
};
export default signOut;
